module.exports = __webpack_public_path__ + "img/al7.179fd3ec.png";